module.exports = __webpack_public_path__ + "static/media/archero2_page_area03_img_en@2x.a4247e27.png";